// @flow
import * as React from "react";
import styled from "styled-components";

import SimpleSpinner from "../Spinners/SimpleSpinner";

const Container = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  width: 100%;
  height: ${props => (props.height ? props.height : "100px")};
`;

type Props = {
  height?: string
};

function Spinner(props: Props) {
  return (
    <Container height={props.height}>
      <SimpleSpinner accent={true} />
    </Container>
  );
}

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Helpdesk/Spinner.js